import { render } from "./ProfileLinks.vue?vue&type=template&id=7dc4708b"
import script from "./ProfileLinks.vue?vue&type=script&lang=js"
export * from "./ProfileLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__